// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"resources_js_pages_AdminChecklistCompanies_vue":1,"resources_js_pages_AdminActivityChecklists_vue":1,"resources_js_pages_AdminActivityPeriods_vue":1,"resources_js_pages_AdminAiUsage_vue":1}[chunkId]) return "js/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};